import React, { useEffect, useRef, useState } from 'react'
import './single-row-data.styles.scss';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const SingleRowData = ({
    data,
    dataKey
}) => {

    const [ dataToDisplay, setDataToDisplay ] = useState(null);
    const [ displayCopyNotification, setDisplayCopyNotification ] = useState([]);
    const notificationRef = useRef([]);

    useEffect(() => {
        if (!data && isNaN(data)) return;
        if (typeof data === 'boolean') {
            if (data) {
                setDataToDisplay('True')
            } else {
                setDataToDisplay('False')
            }
        } else {
            setDataToDisplay(data);
        }
    }, [data])

    function copyToClipboard() {
        navigator.clipboard.writeText(data);
        let tempCopyNotification = [...notificationRef.current];
        tempCopyNotification.push(dataKey);
        notificationRef.current = [...tempCopyNotification];
        setDisplayCopyNotification(notificationRef.current);
        let timeout = setTimeout(() => {
            let tempCopyNotification = [...notificationRef.current];
            tempCopyNotification.splice(tempCopyNotification.indexOf(dataKey), 1);
            notificationRef.current = [...tempCopyNotification];
            setDisplayCopyNotification(notificationRef.current);
            clearTimeout(timeout);
        }, 2000);
    }

  return (
    <div className='single-row-data'>
        {
            (dataToDisplay || !isNaN(dataToDisplay)) &&
            <>
            <b>{dataKey}:</b>
            <span className='data-point' title={dataToDisplay}>
                {
                    isNaN(dataToDisplay) && dataToDisplay.length > 40
                    ?
                    dataToDisplay.substring(0,40) + '...'
                    :
                    dataToDisplay
                }
            </span>
            <button 
                className={`g-button small-btn ${displayCopyNotification.includes(dataKey) ? 'wide' : ''}`}
                onClick={() => copyToClipboard()}>
                {
                    (displayCopyNotification.includes(dataKey))
                    ?
                    <span>Copied!</span>
                    :
                    <FontAwesomeIcon icon={faCopy} />
                }
            </button>
            </>
        }
    </div>
  )
}

export default SingleRowData